import { render, staticRenderFns } from "./marsPatientMed.vue?vue&type=template&id=9fa82994&scoped=true&"
import script from "./marsPatientMed.vue?vue&type=script&lang=js&"
export * from "./marsPatientMed.vue?vue&type=script&lang=js&"
import style0 from "./marsPatientMed.vue?vue&type=style&index=0&id=9fa82994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa82994",
  null
  
)

export default component.exports